module.exports = __webpack_public_path__ + "img/tip.c5b24a78.svg";